import { get } from 'lodash';
export class VideoFreezeAnalyzer {
    constructor(stream, checkInterval) {
        this.measurementError = 0;
        this.defaultCheckInterval = 1000;
        this.previousBytesTransmitted = 0;
        this.isAlreadyFrozen = false;
        this.stream = stream;
        this.checkInterval = checkInterval || this.defaultCheckInterval;
        this.freezeStats = new FreezeStats(this.checkInterval / 1000);
        this.start();
    }
    start() {
        this.intervalHandle = setInterval(() => this.analyze(), this.checkInterval);
    }
    stop() {
        if (Number.isInteger(this.intervalHandle)) {
            clearInterval(this.intervalHandle);
            this.intervalHandle = null;
        }
    }
    get stats() {
        return this.freezeStats.stats;
    }
    async analyze() {
        const hasVideo = this.stream.hasVideo;
        const { video: stats } = await this.stream.getStats();
        if (this.isStreamDestroyed) {
            this.stop();
        }
        if (!hasVideo || !stats) {
            this.isAlreadyFrozen = false;
            return;
        }
        const isNowFrozen = this.isNowFrozen(stats.bytesTransmitted);
        if (isNowFrozen && this.isAlreadyFrozen) {
            this.freezeStats.incrementCurrentSegment();
        }
        else if (isNowFrozen) {
            this.freezeStats.addNewSegment();
        }
        this.isAlreadyFrozen = isNowFrozen;
        this.previousBytesTransmitted = stats.bytesTransmitted;
    }
    get isStreamDestroyed() {
        return get(this.stream, 'stream.destroyed', true);
    }
    isNowFrozen(bytesTransmitted) {
        if (bytesTransmitted <= this.measurementError) {
            return true;
        }
        return (bytesTransmitted - this.previousBytesTransmitted <= this.measurementError);
    }
}
export class FreezeStats {
    constructor(timeStep) {
        this.segments = [];
        this.timeStep = timeStep;
    }
    incrementCurrentSegment() {
        if (!this.segments.length) {
            this.addNewSegment();
            return;
        }
        this.segments[this.segments.length - 1] += this.timeStep;
    }
    addNewSegment() {
        this.segments.push(this.timeStep);
    }
    get stats() {
        return {
            frozenVideoDuration: [...this.segments],
            videoFreezeCount: this.segments.length,
        };
    }
}
